// #region Old Code
import * as React from "react";
import LinkComp from "../LinkComp";
import Icon from "../Icon";
import Alert from "../Alert";
import Tabs from "../Tabs";
import svgSortAsc from "../../svgs/arrow-up.svg";
import ConfirmationDialog  from "../ConfirmDialog";
import "./CRUD.scss";
import EmailPopover from "../ReactTable/EmailPopover";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ReusableSpinner from '../ReactTable/ReusableSpinner';

const CRUDOLD = ({userData, isSeniorAgent, isSuper, originalData, router, tabsData, currentPageRef = null, drawer = null, backLink, edit, children = null, state, setState, handleSubmit, extraHeaderInfo, extraInfo = null, type = "", backName = "", isAgent = false, saveData, title = "", formattedOriginalData = null, formattedLoanQuotesOriginalData = null, formattedPaymentsOriginalData = null, tabsClass = '',updateURL,backToUrl}) => {
    const {data, viewMode, success, error, errorTabs, currentTab, showConfirm=false, isExists=false,filterData = [], currentIndex = 0 } = state;
  const crmBack = sessionStorage.getItem("isCrmback");

let newPath = "";
let path = "";

if (crmBack) {
  [newPath, path] = crmBack.split("|");
}
    const [openEmailPopup,setOpenEmailPopup] = React.useState(false)
    const handleCancel = () => {
        if (!viewMode) {
            if (formattedLoanQuotesOriginalData && formattedPaymentsOriginalData) {
                setState((prevState) => ({
                    viewMode: true,
                    data: formattedOriginalData
                        ? {...formattedOriginalData}
                        : {...prevState.original},
                    [formattedLoanQuotesOriginalData.name]:formattedLoanQuotesOriginalData.data ? formattedLoanQuotesOriginalData.data : prevState[formattedLoanQuotesOriginalData.name],
                    [formattedPaymentsOriginalData.name]:formattedPaymentsOriginalData.data? formattedPaymentsOriginalData.data : prevState[formattedPaymentsOriginalData.name]
                }));
            } else {
                setState((prevState) => ({
                    viewMode: true,
                    data: formattedOriginalData
                        ? {...formattedOriginalData}
                        : {...prevState.original},
                }));
            }
        }
        else if(!data.deleted){
            setState({showConfirm:true})
        }
        else toggleDelete();
    }

    const onCloseConfirm= (val)=>{
        if(val){
            toggleDelete();
        }
        setState({showConfirm:false})
    }

    React.useEffect(() => {
        if (originalData) {
            const logginedUserName = userData.person.firstName + " "+ userData.person.lastName;
            for (let i = 1; i <= 4; i++) {
                const name = (originalData['LISTING_AGENT_' + i + '_FIRST_NAME'] || "") + ' ' + (originalData['LISTING_AGENT_' + i + '_LAST_NAME'] || "");
                if ((isSeniorAgent && (!data.LISTING_AGENT_1 || !data.LISTING_AGENT_2 )) || (isSeniorAgent && name && logginedUserName.toLowerCase()=== name.toLowerCase())) {
                    setState({ isExists: true });
                }
            }
        }
    }, [originalData])
    const toggleDelete = () => {
        if (!data.deleted) {
            data.deleted = 1;
            setState({data}, saveData);
        } else {
            data.deleted = null;
            setState({data}, saveData);
        }
    };

    const nextRecord = () => {
        setState((prevState) => {
          if (prevState.currentIndex < prevState.filterData.length - 1) {
            const newIndex = prevState.currentIndex + 1;
            const newData = prevState.filterData[newIndex];
            updateURL(newData); // Update the URL from CRUDFirm.js, related things i added in CRUDFirm.js
            return { currentIndex: newIndex, data: newData };
          }
          return prevState;
        });
      };
    
      const prevRecord = () => {
        setState((prevState) => {
          if (prevState.currentIndex > 0) {
            const newIndex = prevState.currentIndex - 1;
            const newData = prevState.filterData[newIndex];
            updateURL(newData);
            return { currentIndex: newIndex, data: newData };
          }
          return prevState;
        });
      };
    

    if (data === null) {
        return <ReusableSpinner />
    } else if (data === false) {
        return (
            <Alert type="warn">
                {`${type.charAt(0).toUpperCase()}${type.slice(1)} not found`}
            </Alert>
        );
    } else {
        return (
            <div className="CRUD" ref={currentPageRef}>
                {drawer}
                <div className="CRUD_content">
                    <div className="page-rounded-corner-container">
                        <div className="page-header-container list">
                            {/* <div className="page-back-button" onClick={() => {history.back()}}>
                                <Icon svg={svgSortAsc}/>
                                {backName}
                            </div> */}
                             <div style={{ display: 'flex', alignItems: 'center', width: '80%' }}>
                                                <div
                                                  className="page-back-button"
                                                  onClick={() => {
                                                    // history.back();
                                                   if (newPath) {
                                                     const baseUrl =
                                                       location.origin;
                                                     const pathMap = {
                                                       agent: "contacts/agents",
                                                       vendor:
                                                         "contacts/vendors",
                                                       lender:
                                                         "contacts/lenders",
                                                       tenant:
                                                         "contacts/tenants",
                                                       teamMember:
                                                         "contacts/team-members",
                                                       investor:
                                                         "contacts/investors",
                                                     };
                                                     const url = `${baseUrl}/${pathMap[newPath]}`;
                                                     window.location.href = url;
                                                   }
                                                    else{const baseUrl = location.origin;
                                                    const url = `${baseUrl}${backToUrl}`;
                                                    window.location.href = url;
                                                    }
                                                    sessionStorage.removeItem("isCrmback");
                                                  }}
                                                  style={{ display: 'flex', alignItems: 'center' }}
                                                >
                                                  <Icon svg={svgSortAsc} />
                                                  {backName}
                                                </div>
                                                {state.searchCrudFilter && (
                                                  <div style={{ display: 'flex', gap: '25px', marginLeft: 'auto', color: 'rgb(144, 197, 75)', marginTop:'-10px' }}>
                                                    <ArrowBackIosIcon
                                                      style={{ cursor: state.currentIndex === 0 ? 'not-allowed' : 'pointer' }}
                                                      disabled={currentIndex === 0}
                                                      onClick={prevRecord}
                                                    />
                                                    <ArrowForwardIosIcon
                                                      style={{ cursor: state.currentIndex === state.filterData.length - 1 ? 'not-allowed' : 'pointer' }}
                                                      disabled={currentIndex === filterData.length - 1}
                                                      onClick={nextRecord}
                                                    />
                                                  </div>
                                                )}
                                              </div>
                            <ConfirmationDialog open={showConfirm}  onClose={onCloseConfirm}/>
                            <div className="page-header">
                                <div className="page-title">{edit ? title : "Add " + type}</div>
                                {((isAgent || isSuper || data.SOURCE=='External') || (isExists && data.SOURCE=="STRIVE" && (data.STATUS=="Proposal" || data.STATUS=="Property Info" ))) && <div> {edit ? (
                                    <button className="button-new negative margin-left"
                                            onClick={handleCancel}
                                    >
                                        {viewMode && (data.ARCIMEDES_ROW_ID || data.arcimedes_row_id)
                                            ? data && (data.deleted === "1" || data.deleted === 1)
                                                ? "Undelete"
                                                : "Delete"
                                            : "Cancel"}
                                    </button>
                                ) : (
                                    <LinkComp to={backLink}>
                                        <button className="button-new negative margin-left">Cancel</button>
                                    </LinkComp>
                                )}
                                <button
                                    form={`${type}-form`}
                                    type="submit"
                                    disabled={isAgent || data.deleted === "1" || data.deleted === 1 || (!edit && isSeniorAgent && ((data.SOURCE == 'External' && !(data.STATUS == 'Active' || data.STATUS == 'Closed')) || (data.SOURCE == 'STRIVE' && ! (data.STATUS == 'Proposal'))))}
                                    className={`button-new positive  margin-left ${
                                        (data.deleted === "1" || data.deleted === 1) ? "inactive" : ""
                                    }`}
                                >
                                    {edit ? (viewMode ? "Edit" : "Save") : "Add"}
                                </button>
                                {/* {edit && (
                          <button
                            style={{
                              marginLeft: "18px",
                            }}
                            className="button-new positive"
                            onClick={() => {
                              setOpenEmailPopup(true)
                            }}
                          >
                            Mail
                          </button>
                        )}  */}
                          {edit && (
                          <button
                            style={{
                              marginLeft: "18px",
                            }}
                            className={`button-new positive  margin-left ${
                              data.deleted === 1 ? "inactive" : ""
                            }`}
                            onClick={() => {
                              setOpenEmailPopup(true)
                            }}
                            disabled={
                              data.deleted === 1 
                            }
                          >
                            Mail
                          </button>
                        )}
                        </div> }
                                {extraHeaderInfo}
                    {/* {state.searchCrudFilter && <div style={{ display: 'flex', gap: '25px', marginLeft: '50px', marginTop: "8px", color: "rgb(144, 197, 75)" }}>
                      <ArrowBackIosIcon style={{ cursor: state.currentIndex === 0 ? "not-allowed" : "pointer" }}  disabled={currentIndex === 0} onClick={prevRecord} />
                      <ArrowForwardIosIcon style={{ cursor: state.currentIndex === state.filterData.length - 1 ? "not-allowed" : "pointer" }}  disabled={currentIndex === filterData.length - 1} onClick={nextRecord} />
                    </div>} */}
                            </div>
                        </div>
                    </div>
                    <div className={`page-body-container crud ${type === 'property' ? 'property' : ''}`}>
                        {success ? <Alert type="success">{success}</Alert> : null}
                        {error ? <Alert type="error">{error}</Alert> : null}
                        {errorTabs.length > 0 && currentTab !== 0 ? (
                            <Alert type="error">
                                Unable to add {type} because you have an empty mandatory field
                                on another tab.
                            </Alert>
                        ) : null}

                        <form onSubmit={handleSubmit} id={`${type}-form`} className={`form-container ${isAgent ? 'isAgent' : ''}`}>
                            <Tabs
                                currentTab={state.currentTab}
                                onChangeTab={(tab) => {                                  
                                    if(tabsData[tab].name.indexOf("PROPERTY")>=0 && tabsData[tab].renderedComponent && tabsData[tab].renderedComponent.props.data && tabsData[tab].renderedComponent.props.data.ARCIMEDES_ROW_ID){
                                        router.push("/property/"+tabsData[tab].renderedComponent.props.data.ARCIMEDES_ROW_ID);                                        
                                    }
                                    setState({currentTab: tab})}
                                }
                                errorTabs={errorTabs}
                                tabsData={tabsData}
                                className={tabsClass}
                               
                            />
                        </form>
                {/* <form onSubmit={handleSubmit} id={`${type}-form`} className={`form-container ${isAgent ? 'isAgent' : ''}`}>

                  {typeof state.currentTab === 'number' && tabsData.length > state.currentTab ? (
                    <Tabs
                      currentTab={state.currentTab}
                      onChangeTab={(tab) => {
                        if (
                          tabsData[tab].name.indexOf("PROPERTY") >= 0 &&
                          tabsData[tab].renderedComponent &&
                          tabsData[tab].renderedComponent.props.data &&
                          tabsData[tab].renderedComponent.props.data.ARCIMEDES_ROW_ID
                        ) {
                          router.push("/property/" + tabsData[tab].renderedComponent.props.data.ARCIMEDES_ROW_ID);
                        }
                        setState({ currentTab: tab });
                      }}
                      errorTabs={errorTabs}
                      tabsData={tabsData}
                      className={tabsClass}
                    />
                  ) : null}
                </form> */}

                <EmailPopover openEmailPopup={openEmailPopup} setOpenEmailPopup = {setOpenEmailPopup}/>
                        {extraInfo &&
                            <div className='CRUD_content_extra_info'>
                                <div className='line'/>
                                {extraInfo}
                            </div>
                        }
                    </div>
                </div>
                {children}
            </div>
        );
    }
};

export default CRUDOLD;

//#endregion